import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { GetDistributorListQuery } from "./queries/GetDistributorListQuery";
import { SuggestDistributorsByNameRequest } from "./queries/SuggestDistributorsByNameRequest";
import { CreateDistributorRequest } from "./requests/CreateDistributorRequest";
import { GetDistributorsListResponse } from "./responses/GetDistributorsListResponse";
import { SuggestDistributorsByNameResponse } from "./responses/SuggestDistributorsByNameResponse";

export const useDistributorsApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.catalogueConfig.apiUrl}/distributors`;

    const { httpPost, httpGet } = useAuthorizedFetch();

    const createDistributor = async (request: CreateDistributorRequest): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/create`, request);
    };

    const getDistributorsList = async (query: GetDistributorListQuery): Promise<GetDistributorsListResponse> => {
        return httpGet<GetDistributorsListResponse>(`${baseUrl}/list`, query);
    };

    const suggestDistributorsByName = async (
        query: SuggestDistributorsByNameRequest
    ): Promise<SuggestDistributorsByNameResponse> => {
        return httpGet<SuggestDistributorsByNameResponse>(`${baseUrl}/suggest`, query);
    };

    return {
        createDistributor,
        getDistributorsList,
        suggestDistributorsByName
    };
};
